import React, { useState, useEffect } from "react";
import { X, ShieldOff, CalendarClock } from "lucide-react";
import CenteredAlert from "./CenteredAlert";

const toLocalInputValue = (date = new Date()) => {
  const pad = (n) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

const BlockModal = ({ show, onClose, onConfirm, defaultMessage }) => {
  const [message, setMessage] = useState(defaultMessage || "");
  const [aviso, setAviso] = useState(defaultMessage || "");
  const [agendar, setAgendar] = useState(false);
  const [quando, setQuando] = useState(() => {
    const d = new Date();
    d.setDate(d.getDate() + 3);
    return toLocalInputValue(d);
  });
  const [validationError, setValidationError] = useState("");

  useEffect(() => {
    if (!show) return;
    const base = defaultMessage || "";
    setMessage(base);
    setAviso(base);
    setAgendar(false);
    const d = new Date();
    d.setDate(d.getDate() + 3);
    setQuando(toLocalInputValue(d));
  }, [show, defaultMessage]);

  if (!show) return null;

  const handleConfirm = () => {
    if (agendar) {
      const dt = new Date(quando);
      if (Number.isNaN(dt.getTime()) || dt <= new Date()) {
        setValidationError("Informe uma data/hora futura para o bloqueio programado.");
        return;
      }
      onConfirm({
        mensagemBloqueio: message,
        mensagemAvisoBloqueio: aviso || message,
        bloqueioProgramadoEm: dt.toISOString(),
        agendado: true,
      });
      return;
    }

    onConfirm({ mensagemBloqueio: message, agendado: false });
  };

  return (
    <>
      <CenteredAlert
        show={!!validationError}
        variant="warning"
        message={validationError}
        onClose={() => setValidationError("")}
      />
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} aria-hidden="true" />

      <div className="relative w-full max-w-lg rounded-2xl zen-card p-6 shadow-xl dark:bg-slate-950/80 dark:border-white/10">
        <div className="flex items-start justify-between gap-4 mb-4">
          <div>
            <h5 className="text-xl font-bold text-gray-900 dark:text-white">
              {agendar ? "Agendar bloqueio" : "Bloquear licença"}
            </h5>
            <p className="text-xs text-gray-500 dark:text-slate-300/80 mt-1">
              {agendar
                ? "A licença continua ativa até a data; o Gestão e o PDV exibem aviso amarelo."
                : "Bloqueio imediato da licença ZenGestão."}
            </p>
          </div>

          <button
            onClick={onClose}
            className="p-2 rounded-xl hover:bg-gray-100 dark:hover:bg-white/10"
            title="Fechar"
            type="button"
          >
            <X size={20} className="text-gray-700 dark:text-white" />
          </button>
        </div>

        <div className="space-y-4">
          <label className="flex items-center gap-2 text-sm text-gray-700 dark:text-slate-200">
            <input
              type="checkbox"
              checked={agendar}
              onChange={(e) => setAgendar(e.target.checked)}
              className="rounded border-gray-300"
            />
            Agendar bloqueio futuro
          </label>

          {agendar ? (
            <>
              <div>
                <label className="block text-sm font-medium mb-1">Data e hora do bloqueio</label>
                <input
                  type="datetime-local"
                  value={quando}
                  onChange={(e) => setQuando(e.target.value)}
                  className="w-full px-3 py-2 rounded-xl border dark:bg-slate-950/40 dark:border-white/10"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Mensagem de aviso (amarela)</label>
                <textarea
                  value={aviso}
                  onChange={(e) => setAviso(e.target.value)}
                  className="w-full h-24 p-3 rounded-xl border resize-none dark:bg-slate-950/40 dark:border-white/10"
                />
              </div>
            </>
          ) : null}

          <div>
            <label className="block text-sm font-medium mb-1">
              {agendar ? "Mensagem exibida após o bloqueio" : "Mensagem de bloqueio"}
            </label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="w-full h-28 p-3 rounded-xl border resize-none dark:bg-slate-950/40 dark:border-white/10"
            />
          </div>
        </div>

        <div className="flex flex-col-reverse sm:flex-row justify-end mt-5 gap-2">
          <button
            type="button"
            className="px-4 py-2 rounded-xl font-semibold bg-gray-200 text-gray-800 hover:bg-gray-300 dark:bg-white/10 dark:text-white"
            onClick={onClose}
          >
            Cancelar
          </button>

          <button
            type="button"
            className="inline-flex items-center justify-center gap-2 px-4 py-2 rounded-xl font-semibold bg-red-600 text-white hover:bg-red-500"
            onClick={handleConfirm}
          >
            {agendar ? <CalendarClock size={18} /> : <ShieldOff size={18} />}
            {agendar ? "Agendar bloqueio" : "Bloquear agora"}
          </button>
        </div>
      </div>
    </div>
    </>
  );
};

export default BlockModal;
